import { createLazyComponent, LazyAction, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() => import('./lazyIndex'));

// Export component
export let SaveViewDialog = createLazyComponent(lazyModule, m => m.SaveViewDialog);

// Export actions
export let lazyShowAddOrEditSaveViewDialog = new LazyAction(
    lazyModule,
    m => m.showAddOrEditSaveViewDialog
);

export let lazyShowDeleteSavedViewDialog = new LazyAction(
    lazyModule,
    m => m.showDeleteSavedViewDialog
);
